import React from 'react';
import { Box, useTheme } from '@mui/material';
import { RiCheckboxCircleFill } from 'react-icons/ri';

const BlockCardTag = () => {
	const theme = useTheme();

	return (
		<Box
			sx={{
				display: 'flex',
				borderRadius: '20px',
				color: theme.palette.success.light,
				marginLeft: 1,
			}}
		>
			<RiCheckboxCircleFill size={18} />
		</Box>
	);
};

export default BlockCardTag;
